// src/js/actions/index.js
// import { START_CLICK, MODULE_CLICK, SUBMODULE_CLICK } from "../constants/action-types";

// used in src/js/components/Evaluation/Introduction.js
export function startClick(payload) { return { type: "START_CLICK", payload } }
// used in src/js/components/Evaluation/ModuleIntroduction.js
export function moduleClick(payload) { return { type: "MODULE_CLICK", payload } }
// used in src/js/components/Evaluation/ModuleQuestion .js
export function subModuleClick(payload) { return { type: "SUBMODULE_CLICK", payload } }
// used in src/js/components/Evaluation/ModuleAnswer.js
export function selectAnswerClick(payload) { return { type: "ANSWER_CLICK", payload } }
// used in src/js/components/Evaluation/ModulwComplete.js
export function nextModuleClick(payload) { return { type: "NEXT_MODULE_CLICK", payload } }
export function displayResultsClick(payload) { return { type: "RESULTS_CLICK", payload } }

//used in src/js/componentss/Evaluation/ResultsDownloadForm.js
export function updateFormField(payload) { return { type: "UPDATE_FORM_FIELD", payload } }
export function submitForm(payload) { return { type: "SUBMIT_FORM", payload } }